/**
* @file 翻页
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent} from 'react';
import {Link} from 'gatsby';

const __ = (key: string, lang: string) => {
    const l = lang || 'zh';

    const dict: any = {
        'Previous': {
            zh: '上一篇',
            en: 'Previous',
        },
        'Next': {
            zh: '下一篇',
            en: 'Next',
        }
    };

    return dict[key][l];
};

const PostTurner: FunctionComponent<PostTurnerProps> = ({
    direction,
    path,
    name,
    lang,
}) => {
    if (!path || !name) {
        return null;
    }
    const descMap: any = {
        prev: 'Previous',
        next: 'Next'
    };
    return (
        <div className={`post-turner post-turner--${direction}`}>
            <div className="post-turner__desc">{__(descMap[direction], lang || 'zh')}</div>
            <Link className="post-turner__link" to={path}>{name}</Link>
        </div>
    );
};
export default PostTurner;
